import { render, staticRenderFns } from "./BemVeiculo.vue?vue&type=template&id=0b7b2558"
import script from "./BemVeiculo.vue?vue&type=script&lang=js"
export * from "./BemVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports